import useStyles from './style';
import { Typography, Button, Card, CardContent } from '@mui/material';
import logo from '../../logo.png';
import { useNavigate } from 'react-router-dom';

export const LoginErrorPage = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/');
  };

  return (
    <div className={classes.errorPage}>
      <Card className={classes.card}>
        <img className={classes.logo} src={logo} alt="Logo" />
        <CardContent>
          <Typography variant="h3" className={classes.pageTitle}>
            Login Error
          </Typography>
          <Typography variant="body1" className={classes.message}>
            There was an issue logging you in. Please try again later.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={handleTryAgain}
            className={classes.tryAgainButton}
          >
            Try Again
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
